export default __webpack_public_path__ + "static/media/vue.5f5d1689.svg";